export const getAccountFieldsToEdit = ({
  name,
  entityName,
  email,
  phoneNumber,
}) => [
  {
    fieldName: 'name',
    label: 'Your name',
    value: name,
  },
  {
    fieldName: 'entityName',
    label: 'Legal entity name',
    value: entityName,
  },
  {
    fieldName: 'email',
    label: 'Email address',
    value: email,
  },
  {
    fieldName: 'phoneNumber',
    label: 'Phone number',
    value: phoneNumber,
  },
];
